exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss"), "");
// Module
exports.push([module.id, ".not-found-container-7LQdkrdCmwr{background-color:#F2F2F2;width:100%;height:100vh;display:flex;justify-content:center;align-items:center}.not-found-container-7LQdkrdCmwr>:first-child{text-align:center}.not-found-text-7ojEKdy2mwr{font-size:20px;color:var(--secondary-text);margin-top:50px}.not-found-link-wrapper-LsrptC78mwr{margin-top:20px}.not-found-link-3KAeBB4Fmwr{color:var(--link-text)}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"container": "not-found-container-7LQdkrdCmwr",
	"text": "not-found-text-7ojEKdy2mwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["bold"] + "",
	"link-wrapper": "not-found-link-wrapper-LsrptC78mwr",
	"linkWrapper": "not-found-link-wrapper-LsrptC78mwr",
	"link": "not-found-link-3KAeBB4Fmwr"
};